module.exports = __webpack_public_path__ + "img/Ebay.d55ef9ea.svg";